import React, { useEffect, useState } from "react";
import { viewEmployeeAttendance } from "../../http";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loading from "../Loading";
import { markEmployeeCheckIn, markEmployeeCheckOut } from "../../http";

const Attendance = () => {
  const { user } = useSelector((state) => state.authSlice);
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedDay, setSelectedDay] = useState("");
  const [attendance, setAttendance] = useState();
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [isCheckedOut, setIsCheckedOut] = useState(false);

  const years = [2020, 2021, 2022, 2023, 2024, 2025]; // Customize this as needed
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthDays = {
    January: 31,
    February: 28,
    March: 31,
    April: 30,
    May: 31,
    June: 30,
    July: 31,
    August: 31,
    September: 30,
    October: 31,
    November: 30,
    December: 31,
  };
  const numOfDays = monthDays[selectedMonth];
  const days = Array.from({ length: numOfDays }, (_, index) => index + 1);

  useEffect(() => {
    const storedData = localStorage.getItem(user.id);
    if (storedData) {
      const data = JSON.parse(storedData);
      console.log("Stored Attendance Data:", data);

      const dt = `${data.date}/${data.month}/${data.year}`;
      if (dt === new Date().toLocaleDateString()) {
        setIsCheckedIn(!!data.checkInTime);
        setIsCheckedOut(!!data.checkOutTime);
      } else {
        localStorage.clear();
      }
    }
  }, [user.id]);

  useEffect(() => {
    const dt = new Date();
    const obj = {
      employeeID: user.id,
      year: dt.getFullYear(),
      month: dt.getMonth() + 1,
    };
    const fetchData = async () => {
      const res = await viewEmployeeAttendance(obj);
      const { data } = res;
      setAttendance(data);
    };
    fetchData();
  }, [user.id]);

  // const handleCheckIn = async () => {
  //   console.log("Attempting Check-In...");
  //   const res = await markEmployeeCheckIn({
  //     employeeID: user.id,
  //     latitude: 14.44,
  //     longitude: 79.98,
  //   });

  //   console.log(res);

  //   if (res.success) {
  //     console.log("Check-In Successful:", res.message);
  //     toast.success(res.message);
  //     localStorage.setItem(user.id, JSON.stringify(res.newAttendance));
  //     setIsCheckedIn(true);
  //     setIsCheckedOut(false);
  //   } else {
  //     console.error("Check-In Failed:", res.error);
  //     toast.error("Check-In Failed");
  //   }
  // };
  const getLocationAndCheckIn = async () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        console.log("User Location:", latitude, longitude);

        const res = await markEmployeeCheckIn({
          employeeID: user.id,
          latitude,
          longitude,
        });

        if (res.success) {
          toast.success(res.message);
          localStorage.setItem(user.id, JSON.stringify(res.newAttendance));
          setIsCheckedIn(true);
          setIsCheckedOut(false);
        } else {
          toast.error(res.message);
        }
      },
      (error) => {
        toast.error("Failed to retrieve location");
        console.error("Geolocation error:", error);
      }
    );
  };

  // const handleCheckOut = async () => {
  //   console.log("Attempting Check-Out...");
  //   const res = await markEmployeeCheckOut({
  //     employeeID: user.id,
  //     latitude: 14.44,
  //     longitude: 79.98,
  //   });

  //   if (res.success) {
  //     console.log("Check-Out Successful:", res.message);
  //     toast.success(res.message);
  //     const updatedAttendance = JSON.parse(localStorage.getItem(user.id));
  //     updatedAttendance.checkOutTime = new Date();
  //     localStorage.setItem(user.id, JSON.stringify(updatedAttendance));

  //     setIsCheckedOut(true);
  //     setIsCheckedIn(false);
  //   } else {
  //     console.error("Check-Out Failed:", res.error);
  //     toast.error("Check-Out Failed");
  //   }
  // };
  const getLocationAndCheckOut = async () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        console.log("User Location:", latitude, longitude);

        const res = await markEmployeeCheckOut({
          employeeID: user.id,
          latitude,
          longitude,
        });

        if (res.success) {
          toast.success(res.message);
          const updatedAttendance = JSON.parse(localStorage.getItem(user.id));
          if (!updatedAttendance) {
            localStorage.setItem(user.id, JSON.stringify(res.attendance));
          } else {
            updatedAttendance.checkOutTime = new Date();
            localStorage.setItem(user.id, JSON.stringify(updatedAttendance));
          }

          setIsCheckedOut(true);
          setIsCheckedIn(false);
        } else {
          toast.error("Check-Out Failed");
        }
      },
      (error) => {
        toast.error("Failed to retrieve location");
        console.error("Geolocation error:", error);
      }
    );
  };

  const searchAttendance = async () => {
    const obj = {
      employeeID: user.id,
    };
    if (selectedYear) {
      obj["year"] = selectedYear;
    }
    if (selectedMonth) {
      obj["month"] = months.findIndex((month) => month === selectedMonth) + 1;
    }
    if (selectedDay) {
      obj["date"] = selectedDay;
    }

    const res = await viewEmployeeAttendance(obj);
    const { data } = res;
    setAttendance(data);
  };
  return (
    <>
      {attendance ? (
        <div className="main-content">
          <section className="section">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <div className="card-header d-flex justify-content-between">
                  <h4>Attendance</h4>
                  <div>
                    <button
                      className={`btn btn-lg btn-success ${
                        isCheckedIn ? "disabled" : ""
                      }`}
                      onClick={getLocationAndCheckIn}
                      disabled={isCheckedIn}
                    >
                      Check-In
                    </button>
                    <button
                      className={`btn btn-lg btn-danger ms-2 ${
                        isCheckedOut ? "disabled" : ""
                      }`}
                      onClick={getLocationAndCheckOut}
                      disabled={isCheckedOut}
                    >
                      Check-Out
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-center w-100">
              <div className="col-md col-12 mb-2">
                <select
                  className="form-control select2 w-100"
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                >
                  <option value="">Year</option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md col-12 mb-2">
                <select
                  className="form-control select2 w-100"
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option value="">Month</option>
                  {months.map((month) => (
                    <option key={month} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md col-12 mb-2">
                <select
                  className="form-control select2 w-100"
                  value={selectedDay}
                  onChange={(e) => setSelectedDay(e.target.value)}
                >
                  <option value="">Day</option>
                  {days.map((day) => (
                    <option key={day} value={day}>
                      {day}
                    </option>
                  ))}
                </select>
              </div>
              <button
                onClick={searchAttendance}
                className="btn btn-lg btn-primary col-md col-12 mb-2"
              >
                Search
              </button>
            </div>
          </section>
          <div className="table-responsive">
            <table className="table table-striped table-md center-text">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Day</th>
                  <th>Status</th>
                  <th>CheckIn Time</th>
                  <th>CheckOut Time</th>
                  <th>Camera/Geo Location</th>
                  <th>GMeet</th>
                  <th>Emotion</th>
                </tr>
              </thead>
              <tbody>
                {attendance?.map((attendance, idx) => (
                  <tr>
                    <td>{idx + 1}</td>
                    <td>
                      {attendance.date +
                        "-" +
                        attendance.month +
                        "-" +
                        attendance.year}
                    </td>
                    <td>{attendance.day}</td>
                    <td>
                      {attendance.checkOutTime
                        ? (new Date(attendance.checkOutTime) -
                            new Date(attendance.checkInTime)) /
                            3600000 >=
                          9
                          ? "Present"
                          : "Halfday"
                        : ""}
                    </td>
                    <td>
                      {attendance.checkInTime
                        ? new Date(attendance.checkInTime).toLocaleTimeString()
                        : ""}
                    </td>
                    <td>
                      {attendance.checkOutTime
                        ? new Date(attendance.checkOutTime).toLocaleTimeString()
                        : ""}
                    </td>
                    <td>
                        {attendance.camera
                          ? "Camera"
                          : attendance.withinRange
                          ? "Geo Location"
                          : "NA"}
                      </td>
                      <td>{attendance.gmeet ? "Yes" : "No"}</td>
                      <td>{attendance?.camera ? attendance?.emotion || "N/A" : "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default Attendance;
